import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedUploadURLRPC } from "./getPresignedUploadUrlRPC";

export class GetPresignedUploadURLRPCClientImpl extends GetPresignedUploadURLRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedUploadURLRPC.Request): Promise<LeoRPCResult<GetPresignedUploadURLRPC.Response, GetPresignedUploadURLRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "file-service/GetPresignedUploadURL",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedUploadURLRPC.ResponseDTO,
      GetPresignedUploadURLRPC.Errors.ErrorsDTO,
      GetPresignedUploadURLRPC.Response,
      GetPresignedUploadURLRPC.Errors.Errors
    >(
      response,
      "file-service/GetPresignedUploadURL",
      GetPresignedUploadURLRPC.Response.fromDTO,
      GetPresignedUploadURLRPC.Errors.fromDTO
    );
  }
}
